import { Component, OnInit,Input, EventEmitter, Output } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';

@Component({
  selector: 'app-concept-view',
  templateUrl: './concept-view.component.html',
  styleUrls: ['./concept-view.component.css']
})
export class ConceptViewComponent implements OnInit {
  @Input() id:string;              // 概念主键id（自增长id）
  @Input() parentName:string;      // 父级概念
  formModel:any = {}; // 表单信息
  constructor(
    private kmsService: KmsService,
    private message: SwMassageBoxService,
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    // 根据主键查询概念信息
    this.kmsService.getConceptById(this.id).subscribe(
      result => {
        if (result.code == 200) {
          this.formModel = result.data;
        }else{
          this.message.waring(result.msg);
        }
      }
    )
  }
}
